import { fulfilmentClient } from '../fulfilment-client'
import { datadogRum } from '@datadog/browser-rum'
import { FulfilmentOption } from '../types'

export const getFulfilmentOptions = async (
  vehicleId: string,
): Promise<FulfilmentOption[] | undefined> => {
  try {
    const { data } = await fulfilmentClient.get<FulfilmentOption[]>(
      '/fulfilment-options',
      {
        params: {
          vehicleId,
        },
      },
    )

    return data
  } catch {
    datadogRum.addError(
      new Error(`Error fetching fulfilment options for vehicle ${vehicleId}`),
    )
    return
  }
}
